import React from "react";

const YoutubeVideo = (
  {
    className = "",
    title="",
    youtubeId = "",
    aspectRatio="ratio-16x9",
    showControls= true
  }) => {
  const showControlsParam = showControls ? "" : "?controls=0";
  const youtubeUrl = "https://www.youtube.com/embed/" + youtubeId + showControlsParam;

  return (
    <section className={`youtube-video ${className}`}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className={`ratio ${aspectRatio}`}>
              <iframe
                className="youtube-video__iframe w-100"
                src={youtubeUrl}
                title="YouTube video player" frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            {title && (
              <div className="youtube-video__title mt-3 text-center">{title}</div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default YoutubeVideo
